import { Export } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  DialogClose,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  DrawerClose,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import { exportProfilesToCSV } from "../../../utils";

import type { AudienceProfile } from "../../../types";

interface ExportTargetsProps {
  selectedTargets: AudienceProfile[];
  onSuccess: () => void;
  onBack?: () => void;
}

export default function ExportTargets({
  selectedTargets,
  onSuccess,
  onBack,
}: ExportTargetsProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Close = isDesktop ? DialogClose : DrawerClose;

  const suffix = selectedTargets.length > 1 ? "s" : "";
  const title = "Export targets";
  const description = `Download ${selectedTargets.length} target${suffix} as a CSV file`;

  function handleExport() {
    const a = document.createElement("a");
    a.href = exportProfilesToCSV(selectedTargets);
    a.download = "LinkedInProfiles.csv";
    a.click();
    onSuccess();
  }

  return (
    <>
      <Header title={title} subtitle={description} onBack={onBack} />

      <Footer className="justify-end">
        <Close asChild>
          <Button variant="secondary-black">Cancel</Button>
        </Close>

        <Button leftIcon={<Export weight="fill" />} onClick={handleExport}>
          Export to CSV
        </Button>
      </Footer>
    </>
  );
}
